<template>
<div class="NotFound">
    <h1 class="title">お探しのページが見つかりませんでした</h1>
    <div class="descriptions">
        アドレスが間違っている、またはページが削除・移動された可能性があります。<br/>
        <br/>
        引き続きカーナベルをお楽しみください。
    </div>
    <NuxtLink to="/">
        <Button text="トレカ販売トップ" mode="primary" width="100%" />
    </NuxtLink>
</div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import { Button, TextLink } from '@ka-nabellinc/ka-nabell-ui'
export default defineNuxtComponent({
components: {
    Button,
    TextLink
},
setup(){
    useHead({
        title: '404エラー'
    })
}
})
</script>

<style scoped>
.NotFound {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px
}
.descriptions {
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0.14px;
}
</style>